import rocket from '../assets/images/rocket.png';
import thumb from '../assets/images/thumb.png';
import support from '../assets/images/support.png';

export default function HowItWorks() {
	return (
		<>
			<section className="container my-24 mx-auto px-24 text-center">
				<h2 className="my-5 text-3xl font-bold">How it Works</h2>
				<p className="">
					Select the ideal package for your social media goals from our wide range of options, tailored for different platforms and needs. Simply provide us with your profile link or username – no passwords or extensive permissions are needed. Sit back and watch as we boost your online presence, leveraging real, quality engagement to dramatically enhance your visibility and credibility on social media.
				</p>
			</section>
			<section className="container my-24 mx-auto px-24 text-center">
				<div className="flex flex-row lg:flex-row max-sm:flex-col items-center">
					<div className="text-center my-0 max-sm:my-5">
						<img className="mx-auto flex-none" src={rocket} alt="Delivery" />
						<h2 className="my-5 text-xl font-bold">Instant Followers Delivery</h2>
						<p className="mx-10">Super fast delivery! You will get the service you want in just a moment. Our orders are processed within minutes of purchase, ensuring you get instant results.</p>
					</div>
					<div className="text-center my-0 max-sm:my-5">
						<img className="mx-auto flex-none" src={thumb} alt="Guarantee" />
						<h2 className="my-5 mx-5 text-xl font-bold">High-Quality Followers</h2>
						<p className="mx-10">Not everyone understands the struggle of growing a social media presence, but we do! That is why we provide high-quality followers, all from genuine users and real accounts – absolutely no bots or fakes!</p>
					</div>
					<div className="text-center my-0 max-sm:my-5">
						<img className="mx-auto flex-none" src={support} alt="Support" />
						<h2 className="my-5 text-xl font-bold">24/7 Support</h2>
						<p className="mx-10">Dedicated 24/7 customer support team! We are here to offer you the best service you deserve, and provide you with live support working around the clock!</p>
					</div>
				</div>
			</section>
		</>
	)
}
